import { styled } from '@mui/material/styles';

export const createStyledComponent = <T extends object>(
  Component: any,
  propsToFilter: string[] = []
) => {
  return styled(Component, {
    shouldForwardProp: (prop) => {
      const propStr = prop.toString();
      return !propStr.startsWith('$') && !propsToFilter.includes(propStr);
    }
  });
};

export const createColorFilteredComponent = <T extends object>(Component: any) => {
  return createStyledComponent<T>(Component, ['$color']);
};

export const createPrefixedPropsFilteredComponent = <T extends object>(
  Component: any,
  additionalProps: string[] = []
) => {
  return createStyledComponent<T>(Component, additionalProps);
};
